<template>
  <modal :modal-key="'spin_wheel_modal'"
         @close="$emit('close')"
         class="modal--welcomeback no_space"
         :body-style="'achievement'">
    <template slot="header">
      <template v-if="!determineResult()">
        <h1>{{ getTranslations.home_modals_spin_wheel_congrats }}</h1>
        <h1>{{ getTranslations.home_modals_notifications_spin_wheel_unlocked }}</h1>
      </template>
      <template v-else-if="determineResult() && hasMadeASpin">
        <h1>{{ getTranslations.home_modals_notifications_spin_wheel_yeah }}</h1>
        <h1>{{ getTranslations.home_modals_spin_wheel_win }} {{ getTranslations[prizeName] }}</h1>
      </template>
    </template>
    <template slot="body">
      <div class="spinning_wheel" v-if="!determineResult()">
        <div id="wrapper">
          <div id="wheel">
            <div id="inner-wheel" :class="[disableDuration ? 'noSpin' : 'spinNormal']">
              <div class="sec"><span class="fa fa-bell-o"><img src="static/images/bonus_points.svg" alt=""></span></div>
              <div class="sec"><span class="fa fa-comment-o"><img src="static/images/bonus_points.svg" alt=""></span></div>
              <div class="sec"><span class="fa fa-smile-o"><img src="static/images/bonus_points.svg" alt=""></span></div>
              <div class="sec"><span class="fa fa-heart-o"><img src="static/images/bonus_points.svg" alt=""></span></div>
              <div class="sec"><span class="fa fa-star-o"><img src="static/images/bonus_points.svg" alt=""></span></div>
              <div class="sec"><span class="fa fa-lightbulb-o"><img src="static/images/bonus_points.svg" alt=""></span></div>
            </div>
            <img class="border_wheel" src="static/images/wheel_border.svg" alt="">
            <div id="spinouter">
              <div  id="inner-spin"><img src="static/images/wheel_inside.svg" alt=""></div>
            </div>
            <div id="shine"></div>
          </div>
          <div id="txt"></div>
        </div>
        <a href="#"
           v-if="!hasMadeASpin"
           @click.prevent="spin()"
           id="spin"
           class="btn2 btn2_modal btn2--std btn2--small">
          {{ getTranslations.home_modals_achievements_reward_spin }}
        </a>
      </div>
      <div class="spinning_wheel prize" v-else-if="determineResult() && hasMadeASpin">
        <div class="bounce_box bounce_animation">
          <img class="icon" src="static/images/bonus_points.svg" alt="">
        </div>
        <a href="#"
           @click.prevent="claimPrize()"
           class="btn2 btn2_modal btn2--std btn2--small">
          {{ getTranslations.home_modals_spin_wheel_claim_prize }}
        </a>
      </div>
      <span v-show="showResult && !determineResult() && hasMadeASpin">
       {{ getTranslations.home_modals_spin_wheel_lost }}
      </span>
    </template>
  </modal>
</template>

<script>
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
import Modal from '@/components/home/modals/shared/GenericModal';
import HowToGetPrize from '@/components/home/modals/achievements/HowToGetPrize';
import { spinTheWheel } from '@/common/jQuery';

export default {
  name: 'spin-wheel',
  components: {
    Modal,
  },
  emits: ['read'],
  watch: {
    modalForHome(newValue, oldValue) {
      if (this.watchModal && oldValue && !newValue) {
        this.closeSpin(); // if prize modal closes, you should close as well!
      }
    },
  },
  created() {
    if (this.checkedNotificationId && this.checkedNotificationReadStatus) {
      this.setDisableDuration();
      const spinPosition = this.calculateResult();
      this.$nextTick(() => { spinTheWheel(this.numOfClicks, this.degree, spinPosition); });
      this.hasMadeASpin = true;
      this.setRedeemed();
      this.clicked = true;
      this.prizeName = this.notificationRewardName;
      this.result = this.notificationPrizeWon ? 'WIN' : 'LOSE';
      this.showResult = true;
      this.clearData();
    }
  },
  data() {
    return {
      numOfClicks: 0,
      degree: 1800,
      result: '',
      hasMadeASpin: false,
      clicked: false,
      prizeName: '',
      normalDurationPassed: false,
      haveRewardResponse: false,
      disableDuration: false,
      showResult: false,
      watchModal: false,
    };
  },
  methods: {
    ...mapMutations('profile', [
      'setNotificationRewardId',
      'setCheckedNotificationId',
      'setNotificationRewardName',
      'setNotificationPrizeWon',
      'setCheckedNotificationReadStatus',
      'setRedeemedNotification',
    ]),
    ...mapMutations('common', [
      'storeModalForHomePage',
    ]),
    ...mapActions('profile', [
      'sendNotificationReward',
    ]),
    spin() {
      if (!this.clicked && !this.hasMadeASpin) {
        this.clicked = true;
        this.initSpinCounter();
        const notificationId = this.notificationRewardId ? '' : this.checkedNotificationId;
        this.sendNotificationReward({ reward: this.notificationRewardId, notif: notificationId }).then((response) => {
          this.haveRewardResponse = true;
          if (this.normalDurationPassed) {
            this.showResult = true;
          }
          this.result = JSON.parse(response.data.data).result;
          if (this.result) {
            this.prizeName = JSON.parse(response.data.data).prize || this.notificationRewardName;
            this.hasMadeASpin = true;
            this.setRedeemed();
          }
          this.clearData();
        }).catch((error) => {
          // eslint-disable-next-line
          console.log('error while redeem reward: ' + error);
          this.setDisableDuration();
          this.showResult = true;
          this.hasMadeASpin = true;
          this.setRedeemed();
          spinTheWheel(this.numOfClicks, this.degree, 2); // spin the wheel to "try again" state
        });
        spinTheWheel(this.numOfClicks, this.degree, this.calculateResult());
      }
    },
    setDuration() {
      this.normalDurationPassed = true;
      if (this.haveRewardResponse) {
        this.showResult = true;
      }
    },
    initSpinCounter() {
      setTimeout(this.setDuration, 4000); // do action after 4 seconds passed (minimum spin wheel duration)
    },
    calculateResult() {
      return this.notificationPrizeWon ? this.getRewardId() : 5; // 5: try again state
    },
    getRewardId() {
      return parseInt(this.notificationRewardName.substr(this.notificationRewardName.indexOf('.') + 1), 10) + 1;
    },
    styleClick() {
      return this.clicked ? { 'pointer-events': 'none' } : {};
    },
    setDisableDuration() {
      this.disableDuration = true;
    },
    determineResult() {
      switch (this.result) {
      case 'WIN': return true;
      case 'LOSE':
      default: return false;
      }
    },
    closeSpin() {
      this.setRedeemed();
      this.$emit('close');
    },
    claimPrize() {
      this.storeModalForHomePage(HowToGetPrize);
      this.watchModal = true;
    },
    setRedeemed() {
      this.setRedeemedNotification(this.checkedNotificationId);
      this.$emit('read', this.checkedNotificationId);
    },
    clearData() {
      this.setNotificationRewardId({ value: '' });
      this.setCheckedNotificationId({ value: '' });
      this.setNotificationRewardName({ value: '' });
      this.setNotificationPrizeWon({ value: false });
      this.setCheckedNotificationReadStatus({ value: false });
    },
  },
  computed: {
    modalForHome() {
      return this.modalForHomePage;
    },
    ...mapState('common', [
      'modalForHomePage',
    ]),
    ...mapState('profile', [
      'checkedNotificationId',
      'checkedNotificationReadStatus',
      'notificationRewardId',
      'notificationRewardName',
      'notificationPrizeWon',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
};
</script>

<style scoped>
  .noSpin{
    width:100%;
    height:100%;
    -webkit-transition: all 0s cubic-bezier(0,.99,.44,.99) !important;
    -moz-transition:    all 0 cubic-bezier(0,.99,.44,.99) !important;
    -o-transition:      all 0s cubic-bezier(0,.99,.44,.99) !important;
    -ms-transition:     all 0s cubic-bezier(0,.99,.44,.99) !important;
    transition:         all 0s cubic-bezier(0,.99,.44,.99) !important;
  }
  .spinNormal{
    width:100%;
    height:100%;
    -webkit-transition: all 4s cubic-bezier(0,.99,.44,.99) !important;
    -moz-transition:    all 4 cubic-bezier(0,.99,.44,.99) !important;
    -o-transition:      all 4s cubic-bezier(0,.99,.44,.99) !important;
    -ms-transition:     all 4s cubic-bezier(0,.99,.44,.99) !important;
    transition:         all 4s cubic-bezier(0,.99,.44,.99) !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/home/modals/achievements/SpinWheel.vue